import { ControlGroup } from "@blueprintjs/core";
import React from "react";
import _ from "lodash";
import { nanoid } from "nanoid";
import { masterVisitParameters } from "./masterVisitParameters";
import { initials } from "../../util/util";

class ClinicalVisitParametersPreview extends React.Component {
  state = { areDetailsOpen: false };
  renderPatientParametersAsAdded = () => {
    let patientParameters = this.props.data;
    if (!patientParameters) return null;
    if (!patientParameters.length) return null;
    if (this.props.renderOptions.showOnlyFAInGlassRx) {
      patientParameters = patientParameters.filter((data_entity) =>
        data_entity.nice === "Visual Acuity"
          ? data_entity.subtypeNice.toUpperCase().includes("FINAL ACCEPTANCE")
          : true
      );
    }
    // First we group the patient parameters by their TYPE_ --> parameterType. This is because we want to render them in separate tables.

    let typesOfParams = _.uniq(
      patientParameters.map((each) => each.parameterType)
    );

    // sort typesOfParams by the order in masterVisitParameters
    typesOfParams.sort((a, b) => {
      return (
        masterVisitParameters.map((item) => item.parameterType).indexOf(a) -
        masterVisitParameters.map((item) => item.parameterType).indexOf(b)
      );
    });

    return typesOfParams.map((eachType, tableIndex) => {
      let typeSample = _.find(
        patientParameters,
        (x) => x.parameterType === eachType
      );
      let hasLaterality = typeSample.hasLaterality;
      let hasSubTypes = typeSample.parameterSubtype !== "";
      let whichCase;
      if (hasSubTypes && hasLaterality) {
        whichCase = 0;
      } else if (hasSubTypes && !hasLaterality) {
        whichCase = 1;
      } else if (!hasSubTypes && hasLaterality) {
        whichCase = 2;
      } else if (!hasSubTypes && !hasLaterality) {
        whichCase = 3;
      }
      let whichSubTypes = _.filter(
        patientParameters,
        (x) => x.parameterType === eachType
      );
      // sort subtypes
      if (whichSubTypes.length && whichSubTypes.length > 1) {
        whichSubTypes.sort((a, b) => {
          let master = masterVisitParameters;
          let masterSample = _.find(
            master,
            (x) => x.parameterType === a.parameterType
          );
          let subtypesInMaster = masterSample.parameterSubtypes;
          return (
            subtypesInMaster
              .map((item) => item.parameterSubtype)
              .indexOf(a.parameterSubtype) -
            subtypesInMaster
              .map((item) => item.parameterSubtype)
              .indexOf(b.parameterSubtype)
          );
        });
      }

      if (whichCase === 0) {
        let data = typeSample.data;
        if (typeSample.parameterType === "VISION" && this.props.mode === "RX") {
          if (!this.props.renderOptions.showFullAcuityTable) {
            data = _.filter(data, (x) =>
              ["DISTANCE", "PINHOLE", "NEAR"].includes(x.fieldType)
            );
          }
        }

        return (
          <table
            className="bp4-html-table bp4-compact"
            style={{ marginBottom: "10px", marginRight: "15px" }}
          >
            <thead>
              <tr style={{ fontSize: "smaller", padding: "3px" }}>
                <th
                  rowSpan={2}
                  className="vision_left_border vision_right_border"
                  style={{ padding: "3px !important" }}
                >
                  {typeSample.nice}
                </th>
                {data.map((each, index) => {
                  if (index === 0) {
                    return (
                      <th
                        style={{ padding: "3px" }}
                        colSpan={data.length / 2}
                        className="vision_right_border first_cell"
                      >
                        &nbsp;&nbsp; {_.startCase(_.lowerCase(each.laterality))}
                      </th>
                    );
                  } else if (index === data.length / 2) {
                    return (
                      <th
                        style={{
                          padding: "3px",
                        }}
                        colSpan={data.length / 2}
                        className="first_cell"
                      >
                        &nbsp;&nbsp;{_.startCase(_.lowerCase(each.laterality))}
                      </th>
                    );
                  } else {
                    return null;
                  }
                })}
              </tr>
              {data.length > 2 && (
                <tr style={{ fontSize: "smaller" }}>
                  {data.map((each, index) => {
                    return (
                      <th
                        key={nanoid()}
                        className={
                          index === data.length / 2 - 1
                            ? "vision_right_border narrow_cell "
                            : " narrow_cell"
                        }
                      >
                        {each.nice}
                      </th>
                    );
                  })}
                </tr>
              )}
            </thead>
            <tbody>
              {whichSubTypes.map((each, rowIndex) => {
                let eachOne = each.data;
                if (
                  typeSample.parameterType === "VISION" &&
                  this.props.mode === "RX"
                ) {
                  if (!this.props.renderOptions.showFullAcuityTable) {
                    eachOne = _.filter(eachOne, (x) =>
                      ["DISTANCE", "PINHOLE", "NEAR"].includes(x.fieldType)
                    );
                  }
                }
                return (
                  <tr key={nanoid()} style={{ fontSize: "smaller" }}>
                    <td
                      className="narrow_cell first_cell"
                      style={{
                        padding: "0px",
                        textAlign: "center",
                      }}
                    >
                      {each.subtypeNice}
                    </td>
                    {eachOne.map((eachData, cellIndex) => {
                      return (
                        <td
                          style={{
                            padding: "0px",
                            textAlign: "center !important",
                            verticalAlign: "center !important",
                            border: "1px solid #D3D8DE",
                          }}
                          key={nanoid()}
                          className={
                            cellIndex === eachOne.length / 2 - 1
                              ? "vision_right_border narrow_cell"
                              : "narrow_cell"
                          }
                        >
                          {this.renderCellValue(eachData)}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        );
      }
      if (whichCase === 1) {
        return (
          <div style={{ marginBottom: "10px", marginRight: "15px" }}>
            <ControlGroup>
              {typeSample.nice}
              <div>
                {whichSubTypes.map((each, rowIndex) => {
                  return (
                    <ControlGroup>
                      {each.subtypeNice}
                      {each.data.map((eachData, cellIndex) => {
                        return <>{this.renderCellValue(eachData)}</>;
                      })}
                    </ControlGroup>
                  );
                })}
              </div>
            </ControlGroup>
          </div>
        );
      }
      if (whichCase === 2) {
        return (
          <div style={{ marginBottom: "10px", marginRight: "15px" }}>
            <ControlGroup>
              <b>{typeSample.nice}:</b>&nbsp;&nbsp;
              <div>
                {whichSubTypes.map((each, rowIndex) => {
                  return (
                    <ControlGroup>
                      {each.data.map((eachData, cellIndex) => {
                        return (
                          <ControlGroup>
                            {initials(eachData.laterality)}: &nbsp;&nbsp;
                            {this.renderCellValue(eachData)} &nbsp;&nbsp;
                          </ControlGroup>
                        );
                      })}
                    </ControlGroup>
                  );
                })}
              </div>
            </ControlGroup>
          </div>
        );
      }
      if (whichCase === 3) {
        return (
          <div style={{ marginBottom: "10px", marginRight: "15px" }}>
            <ControlGroup>
              <b>{typeSample.nice}:</b> &nbsp;&nbsp;
              <div>
                {whichSubTypes.map((each, rowIndex) => {
                  return (
                    <ControlGroup>
                      {each.data.map((eachData, cellIndex) => {
                        const isBold = typeSample.parameterType === "GLASS_RX";
                        return (
                          <ControlGroup>
                            &nbsp;&nbsp;
                            {this.renderCellValue(eachData, isBold)}
                          </ControlGroup>
                        );
                      })}
                    </ControlGroup>
                  );
                })}
              </div>
            </ControlGroup>
          </div>
        );
      }
      return null;
    });
  };
  renderCellValue = (eachData, isBold) => {
    const hasUnit = eachData.unit != null && eachData.unit !== "";
    if (Array.isArray(eachData.value)) {
      let text = eachData.value.join(", ");
      if (hasUnit) {
        text = text + " " + eachData.unit;
      }
      return isBold ? <b>{text}</b> : text;
    }
    let text = eachData.value;
    if (hasUnit) {
      text = text + " " + eachData.unit;
    }
    return isBold ? <b>{text}</b> : text || "";
  };
  render() {
    let divStyle = {
      fontSize: "smaller",
      marginBottom: "15px",
      marginRight: "15px",
    };
    if (this.props.mode === "RX") {
      divStyle = {
        ...divStyle,
        display: "flex",
        width: "100%",
        flexWrap: "wrap",
      };
    }
    return (
      <div>
        <div style={divStyle}>{this.renderPatientParametersAsAdded()}</div>
      </div>
    );
  }
}
export default ClinicalVisitParametersPreview;
